import React, { useState, useEffect, Fragment } from "react";
import ExpandableTab from "components/ExpandableTab";

const MultipleExpandableTabs = ({ tabsData = [], closeAll = true }) => {
    const [expandTab, setExpandTab] = useState({});

    useEffect(() => {
        var state = {};
        tabsData.map((obj) => {
            if (!obj.notExpandable) {
                state[obj.id] = obj.expandTab || false;
            }
        });
        setExpandTab(state);
    }, [tabsData]);

    const onTabClick = (id, index) => {
        //  id for expandTab || index for tabsData
        var obj = expandTab;
        if (closeAll) {
            Object.keys(obj).map((key) => {
                obj[key] = false;
            });
        }
        setExpandTab({ ...obj, [id]: !expandTab[id] });
        typeof tabsData[index].onExpandTabClick === "function" && tabsData[index].onExpandTabClick();
    };

    return (
        <>
            {tabsData.map((obj, index) => {
                if (obj.notExpandable) {
                    return <Fragment key={index}>{obj.component()}</Fragment>;
                } else {
                    const Component = obj.children;
                    return (
                        <ExpandableTab
                            key={index}
                            onExpandTabClick={() => onTabClick(obj.id, index)}
                            title={obj.title}
                            expandTab={expandTab[obj.id]}
                        >
                            <Component />
                        </ExpandableTab>
                    );
                }
            })}
        </>
    );
};

export default MultipleExpandableTabs;
